import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom'

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import LoginForm from './LoginForm';
import { UPDATE_JUST_UPDATED_KEY } from '../../UpdateNotification';

const LoginPage = () => {

    const location = useLocation();

    const { from } = location.state || { from: { pathname: '/' } };

    // Snackbar de confirmation affichée après une mise à jour ayant forcé la déconnexion.
    const [updatedVersion, setUpdatedVersion] = useState(null);

    useEffect(() => {
        const justUpdated = localStorage.getItem(UPDATE_JUST_UPDATED_KEY);
        if (justUpdated) {
            setUpdatedVersion(justUpdated);
            // Consommer le flag pour ne l'afficher qu'une seule fois.
            localStorage.removeItem(UPDATE_JUST_UPDATED_KEY);
        }
    }, []);

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            minHeight: 'calc(100vh - 72px)',
            width: '100%',
            bgcolor: 'background.default',
        }}>
            <Paper sx={{
                padding: 4,
                maxWidth: 450,
                width: '90%',
                borderRadius: 0,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}>
                <LoginForm from={from} />
            </Paper>

            <Snackbar
                open={Boolean(updatedVersion)}
                autoHideDuration={8000}
                onClose={() => setUpdatedVersion(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    onClose={() => setUpdatedVersion(null)}
                    sx={{ width: '100%' }}
                >
                    Une nouvelle version est disponible, merci de vous reconnecter.
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default LoginPage;